export const handleDataWarnings = (data) => {
  const warningConditions = [
    { condition: "duplicateBus", message: null },
    { condition: "foreignDivision", message: null },
    {
      condition: "pulloutTimeApproaching",
      message: "Pullout Time Approaching",
    },
    { condition: "pulloutTimePast", message: "Pullout Time Past" },
    {
      condition: "secondaryVehicleType",
      message:
        "Assigned a vehicle that is not the primary or secondary vehicle type",
    },
    { condition: "vehicleTypeMismatch", message: null }, // Special case handled separately
  ];

  return data.map((row) => {
    const warningMessages = warningConditions.reduce(
      (warnings, { condition, message }) => {
        if (
          row[condition] === "Y" ||
          (condition === "vehicleTypeMismatch" && row[condition]) ||
          (condition === "duplicateBus" && row[condition]) ||
          (condition === "foreignDivision" && row[condition])
        ) {
          warnings.push(message || row[condition]);
        }
        return warnings;
      },
      []
    );

    return { ...row, warningMessages };
  });
};
